import Toast from 'src/Toast'
import html from './Helper/html'
import { subscribe } from './MercureEventSource'

const appScriptFileName = document.getElementById('js-app-module')!.getAttribute('src')

let toast: { dismiss: () => void } | null = null
function makeToast () {
    if (toast !== null) {
        return
    }

    const toastHtml = html`<span>An update has been made to Shift One. Please <a id="js-app-updated-refresh" href="#"><strong>refresh</strong></a> the page.</span>`

    toastHtml.querySelector('#js-app-updated-refresh')!.addEventListener('click', function (e) {
        e.preventDefault()
        window.location.reload()
    })

    toast = Toast.info({
        title: 'Update available',
        content: toastHtml,
        dismissable: false,
    })
}

export default function appUpdatedPrompt () {
    const listener = data => {
        if (appScriptFileName === data['appVersion']) {
            return
        }

        makeToast()
    }

    const abortController = new AbortController()
    const signal = abortController.signal

    const checkVersion = async () => {
        if (toast !== null) {
            return
        }

        try {
            const response = await fetch('/version', { signal, cache: 'no-store' })

            if (!response.ok) {
                return
            }

            const version = await response.text()

            if (appScriptFileName !== version) {
                makeToast()
            }
        } catch (err) {
            if (err instanceof Error && (err.name === 'AbortError' || (err.name === 'TypeError' && err.message === 'Failed to fetch'))) {
                return
            }

            throw err
        }
    }

    window.addEventListener('online', checkVersion)

    // SSE pushes are missed while the tab is frozen/throttled or the machine
    // is asleep. All of those show up as a gap between heartbeat ticks, so
    // force a version check when one is detected. The threshold must stay
    // above 2x the interval: Chrome throttles hidden-tab timers to once per
    // minute, which would otherwise trigger on every background tick.
    const heartbeatInterval = 60_000
    let lastHeartbeat = Date.now()
    setInterval(() => {
        const gap = Date.now() - lastHeartbeat
        lastHeartbeat = Date.now()

        if (gap > heartbeatInterval * 2) {
            void checkVersion()
        }
    }, heartbeatInterval)

    window.addEventListener('beforeunload', () => {
        abortController.abort()
    })

    subscribe('app.version', listener)
}
